import HolidayResource from "./holiday.resource";

const holidayModule = angular
  .module("app.resources.holiday", [])
  .service("Holiday", HolidayResource);

export default holidayModule;



// WEBPACK FOOTER //
// ./src/resources/holiday/holiday.module.js